import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './AwardStar.module.scss';
import { Tween, Timeline } from 'react-gsap';
import oneStar from 'icons/one-star.png';
import { random } from 'lodash';
import { connect } from 'react-redux';
import { hideBackgroundOfAward } from 'store/actions/award';
import { t } from '../../translations';

export class AwardStar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      background: '#FFF',
      x: 0,
      y: 0
    };

    this.randomSound = random(0, 4);
  }

  componentDidMount() {
    const {
      props: { target }
    } = this;
    let [x, y] = [0, 0];
    const { left, top, width, height } = this.selfRef.getBoundingClientRect();
    if (target && target.current && 'getBoundingClientRect' in target.current) {
      let star = target.current.getBoundingClientRect();
      const offsetTop = -star.height / 2 + height / 2;
      const offsetLeft = -star.width / 2 + width / 2;
      [x, y] = [star.left - left - offsetLeft, star.top - top - offsetTop];
    }

    this.setState({ x, y });

    //Play a random reward sound
    this.props.rewardSounds[this.randomSound].play();
  }

  makeSpiralCoords = () => {
    let radius = 300;
    const step = 100;
    const coords = [];
    while (radius >= 0) {
      if (0 === radius) {
        coords.push({ x: 0, y: 0 });
      } else {
        coords.push(
          { x: radius, y: 0 },
          { x: 0, y: radius },
          { x: -radius, y: 0 },
          { x: 0, y: -radius }
        );
      }

      radius -= step;
    }
    return coords;
  };

  render() {
    const {
      props: { earnedStar, level, onComplete, rewardSounds, hideBackgroundOfAward },
      state: { background, x, y }
    } = this;

    return (
      <div className={styles.Overlay} style={{ background }}>
        <div className={styles.AwardStarScreen}>
          <div className={styles.AwardStar} ref={ref => (this.selfRef = ref)}>
            {x && y && (
              <Timeline target={<img src={oneStar} alt={t('oneStar')} />} onComplete={onComplete}>
                <Tween
                  to={{ scale: 4 }}
                  bezier={{ curviness: 2, values: this.makeSpiralCoords() }}
                  duration={5}
                  ease={'Power0.ease'}
                />
                <Tween to={{ scale: 8 }} ease={'Elastic.easeOut'} duration={1.2} />
                <Tween
                  to={{ scale: 4 }}
                  ease={'Elastic.easeIn'}
                  duration={1}
                  onComplete={() => {
                    this.setState({ background: 'transparent' }, () => hideBackgroundOfAward());
                    rewardSounds[this.randomSound].stop();
                    const whichStar = level === 1 ? 0 : 1;
                    earnedStar[whichStar].play();
                  }}
                />
                <Tween
                  to={{ scale: 0.2, x: x, y: y }}
                  delay={1}
                  duration={1.4}
                  ease={'Bounce.easeOut'}
                />
              </Timeline>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AwardStar.propTypes = {
  earnedStar: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.bool])),
  rewardSounds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.bool])),
  level: PropTypes.number.isRequired,
  onComplete: PropTypes.func.isRequired,
  target: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  hideBackgroundOfAward: PropTypes.func
};

const mapStateToProps = state => ({
  earnedStar: [state.ui.sounds.common.earnedAStar, state.ui.sounds.common.earnedAnotherStar],
  rewardSounds: state.ui.sounds.common.affirmations
});

const mapDispatchToProps = {
  hideBackgroundOfAward
};

export default connect(mapStateToProps, mapDispatchToProps)(AwardStar);
